export { default as Homepage } from './lib/homepage'
export type { VehiclesData } from './lib/types/vehicles-data'
export { getHomePageVehiclesData } from './lib/data/vehicles'
export { getHomePageContentData } from './lib/data/content'

export type {
  HomeStoryContent,
  PersonalisedSection,
} from './lib/types/home-story-content'

export { getServerSideProps } from './lib/get-server-side-props'

export { Filters } from './lib/components/hero-v2/filters'
